import sidebar from '@/config/sidebars/geogrids'
import createVueApp from '@/common/createApp'

Styxie.Initializers.GeogridRequests = {
  index: async(props) => {
    const { default: Component } = await import('@/vue_widgets/geogrids/widgets/requests/index.vue')
    const { wlcDomain, geogridWidget } = props
    createVueApp(Component, { props: { wlcDomain, widget: geogridWidget }, sidebar })
  }
}
